<template>
  <a v-if="href" :href="href" class="btn has-icon" @click="$emit('click', $event)" :style="style" target="_blank">
    <icon class="btn-icon" v-if="icon" :name="icon" :bg="color" fill="white" />
    <slot></slot>
  </a>
  <button v-else class="btn has-icon" @click="$emit('click', $event)" @dblclick="$emit('dblclick', $event)" :style="style">
    <icon class="btn-icon" v-if="icon" :name="icon" :bg="reverse ? 'white' : color" :fill="reverse ? color : 'white'" />
    <slot></slot>
  </button>
</template>

<script>
  export default {
    props: {
      color: null,
      href: null,
      icon: null,
      reverse: false,
      textColor: null,
      bgColor: null
    },
    computed: {
      style () {
        let styleString = ''
        if (this.color === '#E2260F') {
          styleString += 'box-shadow: 0 2px 6px rgba(226, 38, 15, 0.25);\n'
        }
        if(this.textColor){
          styleString += 'color: ' + this.textColor + ';\n'
        }
        if(this.bgColor){
          styleString += 'background-color: ' + this.bgColor + ';\n'
        }
        return styleString
      } 
    }
  }
</script>

<style>
.btn {
  position: relative;
  margin: 5px;
  border: none;
  box-shadow: none;
  border-radius: 10px;
  line-height: 20px;
  padding: 20px 2px 15px;
  background: #fff;
  color: black;
  outline: none;
  display: inline-block;
  box-sizing: border-box;
  font: inherit;
  -webkit-font-smoothing: unset;
  -moz-osx-font-smoothing: unset;
  box-shadow: 0px 2px 6px rgba(0, 90, 166, 0.16);
  text-decoration: none;
  text-align: center;
}

.btn + .btn {
  margin-left: 0.5em;
}
.btn-icon.icon {
  position: relative;
  top: -2px;
  margin-right: 10px;
  display: inline-block;
  vertical-align: middle;
  line-height: 22px;
  height: 32px;
  width: 32px;
  padding: 4px;
  border-radius: 32px;
  font-size: 24px;
  box-sizing: border-box;
}
.btn-icon svg {
  display: block;
  width: 1em;
  height: 1em;
}
.btn-icon path {
  /*fill: white;*/
}
</style>
